
<mat-card>
  <mat-card-content>
    <label>Il tuo pagamento e stato processato correttamente.</label>
    <br /><br />
    <button mat-raised-button
            color="primary" (click)="btnTornaAllaDashboard()">
      Torna alla dashboard
    </button>

  </mat-card-content>
</mat-card>
